import type { DecorationScreenSchema } from "./types";

export const cartSchema = {
	back_button: { css: [], variant: { values: ["text", "icon"], default: "text" }, icon: true },
	back_wrapper: { css: [] },
	bonus_button: { css: [] },
	close_button: { css: [], visible: false, icon: true },
	comment_area: { css: [] },
	comment_back: { css: [], icon: true },
	comment_button: { css: ["filled"], variant: { values: ["text", "icon"], default: "text" }, icon: true },
	comment_chip: { css: [] },
	comment_chips: { css: [], visible: false },
	comment_close: { css: [], icon: true },
	comment_counter: { css: [] },
	comment_editor: { css: [], variant: { values: ["inline", "overlay"], default: "inline" } },
	comment_field: { css: [] },
	comment_head: { css: [] },
	comment_hint: { css: [] },
	comment_limit: { css: [], visible: true },
	comment_line: { css: [], visible: false },
	comment_line_action: { css: [] },
	comment_line_icon: { css: [], icon: true },
	comment_line_text: { css: [] },
	comment_meta: { css: [] },
	comment_save: { css: [], visible: true },
	comment_title: { css: [] },
	comment_veil: { css: [] },
	comment_wrapper: { css: [] },
	completed: { css: ["paid"] },
	dock: { css: [] },
	empty: { css: [], visible: false },
	empty_button: { css: [] },
	empty_icon: { css: [], icon: true },
	empty_subtitle: { css: [] },
	empty_title: { css: [] },
	footer: { css: ["paying"] },
	footer_buttons: { css: [] },
	header: { css: ["paying"] },
	header_row: { css: [] },
	kso_actions: { css: [] },
	kso_bonus_amount: { visible: true },
	kso_bonus_button: { css: ["active"] },
	kso_bonuses: { css: [] },
	kso_bonuses_all: { css: [] },
	kso_bonuses_caret: { css: [] },
	kso_bonuses_controls: { css: [] },
	kso_bonuses_draft: { css: [] },
	kso_bonuses_field: { css: ["invalid"] },
	kso_bonuses_notice: { css: ["muted"] },
	kso_bonuses_ok: { css: [] },
	kso_bonuses_placeholder: { css: [] },
	kso_close: { css: [], visible: false, icon: true },
	kso_content: { css: [] },
	kso_created: { css: [] },
	kso_created_body: { css: ["bonuses"] },
	kso_cup: { css: [] },
	kso_cup_icon: { css: ["default"] },
	kso_cup_ring: { css: ["inner", "middle", "outer"] },
	kso_cup_rings: { variant: { values: ["pulse"], default: null } },
	kso_cup_stage: { css: [] },
	kso_cup_steam: { css: [] },
	kso_cup_steam_puff: { css: [] },
	kso_discount_percent: { visible: false },
	kso_footer: { css: ["bonuses"] },
	kso_grip: { visible: true },
	kso_header: { css: ["created", "creating", "methods"] },
	kso_key: { css: [] },
	kso_keypad: { css: [] },
	kso_list: { css: [] },
	kso_loader: { css: [], variant: { values: ["simple", "immersive"], default: null } },
	kso_loader_body: { css: [] },
	kso_loader_caption: { css: [] },
	kso_loader_close: { css: [], icon: true },
	kso_loader_dot: { css: [] },
	kso_loader_dots: { css: [] },
	kso_loader_fill: { css: [] },
	kso_loader_glare: { css: [], visible: true },
	kso_loader_phrase: { css: [] },
	kso_loader_phrase_box: { css: [] },
	kso_loader_progress: { css: [] },
	kso_loader_title: { css: [] },
	kso_method: { css: [] },
	kso_method_description: { css: [] },
	kso_method_go: { css: [], icon: true },
	kso_method_icon: { css: [] },
	kso_method_icon_card: { icon: true },
	kso_method_icon_cash: { icon: true },
	kso_method_icon_sbp: { icon: true },
	kso_method_icon_tracker: { icon: true },
	kso_method_icon_yandex: { icon: true },
	kso_method_name: { css: [] },
	kso_method_text: { css: [] },
	kso_methods: { css: [] },
	kso_methods_back: { css: [] },
	kso_methods_footer: { css: [] },
	kso_methods_list: { css: [] },
	kso_methods_subtitle: { css: [] },
	kso_methods_title: { css: [] },
	kso_methods_total: { css: [], visible: true },
	kso_pay_amount: { css: [] },
	kso_pay_button: { css: ["disabled"], variant: { values: ["text", "split"], default: "text" }, locked: true },
	kso_pay_label: { css: [] },
	kso_row: { css: ["available", "discount", "total"] },
	kso_row_label: { css: ["available", "discount", "total"] },
	kso_row_value: { css: ["available", "discount", "total"] },
	kso_sheet: { css: ["created", "creating", "methods", "waves"] },
	kso_title: { css: [] },
	kso_wave_back: { css: [] },
	kso_wave_front: { css: [] },
	kso_wave_paths: { visible: true },
	kso_waves: { css: [], visible: null },
	line: { css: [] },
	line_badge: { css: [] },
	line_badge_text: { css: [] },
	line_badges: { css: [] },
	line_content: { css: [] },
	line_image: { css: [] },
	line_info: { css: [] },
	line_modifiers_toggle: { css: [], visible: true },
	line_more: { css: [] },
	line_name: { css: [] },
	line_new_price: { css: [] },
	line_old_price: { css: [], visible: false },
	line_option: { css: ["size"] },
	line_option_price: { css: [] },
	line_options: { css: [], visible: false },
	line_photo: { css: [] },
	line_price: { css: ["discount"] },
	line_remove: { css: [], variant: { values: ["close", "cross"], default: "close" }, icon: true },
	line_size: { css: [], visible: true },
	line_stepper: { css: [] },
	line_stepper_button: { css: [], variant: { values: ["text", "icon"], default: "text" } },
	line_stepper_count: { css: [] },
	line_stepper_minus: { icon: true },
	line_stepper_plus: { icon: true },
	list: { css: ["paying"] },
	loyalty_button: { css: ["authorized"], variant: { values: ["text", "icon"], default: "text" }, icon: true },
	loyalty_wrapper: { css: [] },
	min_order_notice: { css: [] },
	nutrition: { css: [], visible: true },
	order_tabs: { css: [], visible: true },
	page: { css: ["empty"] },
	paid: { css: [], variant: { values: ["card"], default: null } },
	paid_actions: { css: [] },
	paid_bar: { css: [], variant: { values: ["countdown"], default: null } },
	paid_button: { css: [] },
	paid_card: { css: [] },
	paid_hint: { css: [], visible: false },
	paid_icon: { css: [], visible: true },
	paid_label: { css: [] },
	paid_logo: { css: [], visible: false, icon: true },
	paid_media: { visible: true },
	paid_number: { css: [] },
	paid_plate: { css: [] },
	paid_plate_label: { css: [], visible: false },
	paid_qr: { css: [] },
	paid_qr_wrap: { css: [] },
	paid_seconds: { css: [], visible: true },
	paid_shade: { visible: true },
	paid_subtitle: { css: [] },
	paid_title: { css: [] },
	paid_wrap: { css: [] },
	pay_button: { css: ["disabled", "empty"], variant: { values: ["text", "total"], default: "text" }, icon: true, locked: true },
	paying_dim: { css: ["creating", "methods"], visible: false },
	sheet: { css: [], variant: { values: ["page", "sheet"], default: "page" } },
	sheet_card: { css: ["paying"] },
	sheet_veil: { css: [] },
	summary: { css: [], visible: false },
	summary_badge: { css: [] },
	summary_label: { css: ["discount"] },
	summary_row: { css: ["discount"] },
	summary_value: { css: ["discount"] },
	totals: { css: [], visible: true },
} as const satisfies DecorationScreenSchema;
